import React from 'react'
import PropTypes from 'prop-types'
import {Flex, useStyleConfig} from '@chakra-ui/react'
import Benefit from './benefit'
// import {BRAND_KEY} from '../../brand'

const BenefitBar = ({benefitGroup = []}) => {
    const styles = useStyleConfig('PreFooter')
    const visibleBenefits = benefitGroup.slice(0, 4)

    return (
        <>
            <Flex {...styles.container} data-testid="benefit-bar-container">
                <Flex {...styles.benefitBarContainer}>
                    {visibleBenefits.map(({title, description, icon}, index) => (
                        <React.Fragment key={index}>
                            <Benefit
                                title={title}
                                description={description}
                                url={icon?.url}
                                alt={icon?.description}
                                hsaBorder={index !== visibleBenefits.length - 1}
                            />
                        </React.Fragment>
                    ))}
                </Flex>

                {/* <Flex sx={styles.benefitBarSwiper} data-testid="benefit-bar-swiper">
                    {BRAND_KEY === 'kenwood' ? (
                        <BenefitIconsSwiperKenwood benefitGroup={benefitGroup} />
                    ) : (
                        <BenefitIconsSwiper benefitGroup={benefitGroup} />
                    )}
                </Flex> */}
            </Flex>
        </>
    )
}

BenefitBar.getTemplateName = () => 'benefit-bar'

BenefitBar.propTypes = {
    benefitGroup: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string}),
            title: PropTypes.string,
            description: PropTypes.string,
        }),
    ),
}

export default BenefitBar
